import React from "react";

import BasePolicyPicker from "../../../../components/PolicyPicker";
import {
  getRouteFormProperty,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { useDispatch, useSelector } from "../../../../store";
import { EntityInfo, Route } from "../../../../store/pomeriumApi";

type PolicyPickerProps = {
  readonly: boolean;
  route?: Route;
  showAdd?: boolean;
};
const PolicyPicker = ({ readonly, route, showAdd }: PolicyPickerProps) => {
  const dispatch = useDispatch();
  const selectedPolicies = useSelector(
    getRouteFormProperty("policies", []),
  ) as EntityInfo[];

  const handleChange = (newPolicies: EntityInfo[]) => {
    dispatch(
      setRouteFormProperty({
        path: "policyIds",
        value: newPolicies.map((p) => p.id),
      }),
    );
    dispatch(
      setRouteFormProperty({
        path: "policies",
        value: newPolicies,
      }),
    );
  };
  return (
    <BasePolicyPicker
      readonly={readonly}
      policies={selectedPolicies}
      onChange={handleChange}
      route={route}
      showAdd={showAdd}
    />
  );
};
export default PolicyPicker;
